import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import AutocodeGridHeaders from './AutocodeGridHeaders';
import AutocodeGridBody from './AutocodegridBody';

const AutocodeGrid = props => {
  const {
    title,
    gridarray,
    minRows,
    gridCategory,
    onGridDrop,
    height,
    width,
    weightType,
    selectedData,
    clearSelections,
    setCheckBlur,
    partsToShow,
    handleRowMouseDown,
    handleRowMouseUp,
  } = props;

  return (
    <Fragment>
      <div className="grid-container" data-test="AutocodeGrid">
        <AutocodeGridHeaders
          title={title}
          count={gridarray.filter(data => data.id).length}
          weightType={weightType}
          gridCategory={gridCategory}
        />
        <AutocodeGridBody
          columns={title.length}
          gridarray={gridarray}
          minRows={minRows}
          onGridDrop={onGridDrop}
          gridCategory={gridCategory}
          height={height}
          minwidth={width}
          selectedData={selectedData}
          clearSelections={clearSelections}
          setCheckBlur={setCheckBlur}
          partsToShow={partsToShow}
          handleRowMouseDown={handleRowMouseDown}
          handleRowMouseUp={handleRowMouseUp}
        />
      </div>
    </Fragment>
  );
};

AutocodeGrid.propTypes = {
  title: PropTypes.arrayOf(PropTypes.object),
  gridarray: PropTypes.arrayOf(PropTypes.object),
  minRows: PropTypes.number,
  gridCategory: PropTypes.string,
  onGridDrop: PropTypes.func,
  height: PropTypes.string,
  width: PropTypes.number,
  weightType: PropTypes.string,
  selectedData: PropTypes.arrayOf(PropTypes.string),
  clearSelections: PropTypes.func,
  setCheckBlur: PropTypes.func,
  partsToShow: PropTypes.shape({}),
};

export default AutocodeGrid;
